import GallerySliderInstance, { Pagination } from 'swiper/core';

GallerySliderInstance.use(Pagination);

const gallerySlider = document.querySelectorAll('.c-slider--image-gallery');

if (gallerySlider) {
  gallerySlider.forEach(slider => {
    const { slideCount } = slider.dataset;
    const sliderPagination = slider.querySelector('.c-slider__pagination');
    const options = {
      pagination: {
        el: sliderPagination,
        clickable: true,
        type: 'bullets',
        bulletClass: 'c-slider__pagination-bullet',
        bulletActiveClass: 'c-slider__pagination-bullet--active',
      },
      loop: true,
      init: false,
      slidesPerView: 1,
      spaceBetween: 16,
      breakpoints: {
        1024: {
          slidesPerView: Number(slideCount),
        },
      },
    };
    const sliderInstance = new GallerySliderInstance(slider, options);

    sliderInstance.init();
  });
}



// WEBPACK FOOTER //
// ./src/scripts/modules/imageSlider.js